import { apiClient } from '../../../common/ApiClient';
import { RcFile } from 'antd/es/upload';
import { expand } from 'uri-template-lite';
import { InputDataEditSessionUrl } from '../InputDataEditSessionUrl';
import { createApiMutationHook } from '../../../common/queryClient/createApiMutationHook';

const mutateSubjectInputDataUpload = async ({
  sessionId,
  file,
  onProgress,
}: {
  sessionId: string;
  file: string | Blob | RcFile;
  onProgress?: (progress: number) => void;
}) =>
  apiClient
    .post(
      expand(InputDataEditSessionUrl.excelUpload, { sessionId }),
      { file },
      {
        headers: { 'content-type': 'multipart/form-data' },
        onUploadProgress: (progress) => {
          if (!progress.total) {
            return;
          }
          onProgress?.((progress.loaded / progress.total) * 100);
        },
      },
    )
    .then((response) => response.data);

export const useMutateSubjectInputDataUpload = createApiMutationHook(
  ['input-data-excel-upload'],
  mutateSubjectInputDataUpload,
);
